import { render, staticRenderFns } from "./RecoTextSearch.vue?vue&type=template&id=775977ce&"
import script from "./RecoTextSearch.vue?vue&type=script&lang=js&"
export * from "./RecoTextSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports